module.exports = __webpack_public_path__ + "static/assets/3e8f34646d0a803acbf66625558ee319.svg";